import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '@/context/LanguageContext';
import TncBody from '@/components/TncBody';
import { ArrowLeft, ScrollText } from 'lucide-react';

/** Public standalone Terms & Conditions page — direct link (SEO-friendly, shareable). */
export default function TermsPublicPage() {
  const { lang } = useLang();
  const isID = lang !== 'en';

  useEffect(() => {
    const prevTitle = document.title;
    document.title = isID
      ? 'Syarat dan Ketentuan · Match Group Indonesia'
      : 'Terms and Conditions · Match Group Indonesia';
    return () => { document.title = prevTitle; };
  }, [isID]);

  return (
    <div className="min-h-screen t-bg">
      <header className="sticky top-0 z-40 glass px-4 py-3" style={{ borderBottom: '1px solid var(--border-color)' }}>
        <div className="max-w-3xl mx-auto flex items-center gap-2">
          <Link to="/" data-testid="tnc-page-back" className="flex items-center gap-1 text-sm t-text-muted hover:text-[#D98A94]">
            <ArrowLeft className="w-4 h-4" />
            {isID ? 'Kembali' : 'Back'}
          </Link>
          <ScrollText className="w-5 h-5 text-[#D98A94] ml-2" />
          <h1 className="text-base font-semibold t-text">
            {isID ? 'Syarat dan Ketentuan' : 'Terms and Conditions'}
          </h1>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-6" data-testid="tnc-public-page">
        <TncBody lang={lang} />
      </main>
    </div>
  );
}
